import { majorReviews } from '@/mocks/gossip';

export default function MajorReviews() {
  return (
    <section id="major" className="scroll-mt-24 py-10 md:py-14 bg-background-950 text-background-50">
      <div className="container-site">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-1.5 rounded-full bg-accent-400"></span>
              <span className="text-xs font-medium tracking-widest text-background-50/60">FEATURED ARCHIVE</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-background-50">
              大事件<span className="text-accent-400">回顾</span>
            </h2>
            <p className="mt-3 text-background-50/70 max-w-xl leading-relaxed">
              不止吃瓜，更要读懂背后的趋势。年度重磅专题，一次讲透一个现象级话题的来龙去脉。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {majorReviews.map((m) => (
            <article key={m.id} className="group flex flex-col rounded-2xl overflow-hidden bg-background-900 hover:-translate-y-1 transition duration-300">
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={m.cover}
                  alt={m.title}
                  className="w-full h-full object-cover object-center transition duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 font-display text-lg tracking-wider px-3 py-1 rounded-md bg-accent-400 text-foreground-950">{m.num}</span>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-md bg-background-950/70 text-background-50 text-xs">{m.year} 专题</span>
              </div>
              <div className="flex flex-col flex-1 p-5 md:p-6">
                <h3 className="text-lg font-bold leading-snug group-hover:text-accent-300 transition">{m.title}</h3>
                <p className="mt-1 text-sm text-accent-400/90">{m.sub}</p>
                <p className="mt-3 text-sm text-background-50/70 leading-relaxed flex-1">{m.desc}</p>
                <a href="#annual" className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-accent-300 hover:text-accent-200 transition whitespace-nowrap">
                  进入专题阅读 <i className="ri-arrow-right-up-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}